module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Could not find anything":"Es konnte nichts gefunden werden"}}')
  delete Component.options._Ctor
}
